import { lt } from '@mews/framework';
import { Button, Dialog, IconName } from '@optimus-web/core';

interface DeleteDialogProps {
    title: React.ReactNode;
    description: React.ReactNode;
    isActive: boolean;
    onClose: () => void;
    onDelete: () => void;
    loading?: boolean;
}
export const DeleteDialog = ({ title, description, isActive, onClose, onDelete, loading }: DeleteDialogProps) => {
    const footer = {
        primary: (
            <Button variant="destructive" onClick={onDelete} icon={IconName.Delete} type="submit">
                {lt('Delete')}
            </Button>
        ),
        secondary: (
            <Button variant="tertiary" onClick={onClose} type="button">
                {lt('GoBack')}
            </Button>
        ),
    };

    return (
        <Dialog active={isActive} title={title} size="small" onClose={onClose} footer={footer} loading={loading}>
            {description}
        </Dialog>
    );
};
